const { createContext } = require("react");

const DataLoadingContext = createContext(null);

export default DataLoadingContext;
